import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// CSS responsive/logos rapatrie de build/ : importe APRES App pour passer
// apres le CSS des pages. Modifier src, puis reconstruire build/ ; ne pas
// modifier build/ a la main.
import './cgl-responsive-global.css';

// Le backend Django utilise des cookies de session SameSite=Lax : ouvrir le
// frontend sur localhost alors que l'API tourne sur l'IP LAN casse l'envoi
// du cookie sur toute requete cross-site (login qui ne "tient" jamais).
// Redirection auto vers la meme IP que le backend pour eviter ce piege.
if (window.location.hostname === 'localhost') {
  window.location.replace(window.location.href.replace('localhost', '192.168.1.41'));
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
